import Emails from "../components/Emails";

const AllEmails = () => {
    return (
        <Emails tagFilters/>
    );
};
export default AllEmails;
